import React from 'react';
import { LocalizationFlags } from '@draftkings/sportsbook-common-contracts';
import type { SportSliderDict } from '@draftkings/sportsbook-labels';

export type AppContextProps = {
    dictionary: SportSliderDict;
    locale?: string;
    localizationFlags?: LocalizationFlags;
};

export const AppContext = React.createContext<AppContextProps | undefined>(undefined);
